import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";

export const ExpandableSection = ({
  title,
  children,
  classes,
  expanded = false,
}) => (
  <Accordion
    elevation={0}
    className={classes.storyPanelDFP}
    square
    defaultExpanded={expanded}
  >
    <AccordionSummary
      expandIcon={
        <img
          src="/img/icons/chevron-down.svg"
          alt="Expand"
          style={{ width: "28px", height: "28px" }}
        />
      }
    >
      <Typography variant="h6" className={classes.teaserAccordionSummaryText}>
        {title}
      </Typography>
    </AccordionSummary>
    <AccordionDetails>{children}</AccordionDetails>
  </Accordion>
);
